"use client";

import { Container, Grid } from "@mui/material";
import { useSearchParams } from "next/navigation";
import { useCallback, useState } from "react";
import { Product } from "src/lib/fetcher/client";
import ProductFilterCard from "../product-details/default/product-filter-card";
import SalifyFallback from "../salify-fallback/default";
import ProductResultList from "../salify-next-layout/default/components/products-view/product-result-list";
import SearchResultControl from "./default/search-result-control";

export interface VariantProps {
  orderByOptions: Array<{ label: string; value: string }>;
  featuredOption?: string;
}

const SalifyCollectionSection = (props: VariantProps) => {
  const searchParams = useSearchParams();
  const search = searchParams?.get("q") ?? "";
  const orderBy = searchParams?.get("orderBy") ?? props.orderByOptions?.[0]?.value;
  const currentPage = +(searchParams?.get("page") ?? 1);
  const [view, setView] = useState("grid");
  const toggleView = useCallback((v: string) => () => setView(v), []);
  const products = SalifyFallback.useSelect<Product[]>("output:products.data");
  const { limit, total, offset } = SalifyFallback.useSelect("output:products.paging");
  const pagingText = (
    <SalifyFallback.LabelTemplate
      path="pagingText"
      default="Showing {{range}} of {{total}} product(s)"
      params={{
        range: total > 0 ? `${+offset + 1}-${Math.min(offset + limit, total)}` : 0,
        total,
      }}
    />
  );
  const featuredBgImg = props.featuredOption || "misc/featured-background-opt1.png";

  return (
    <Container
      sx={{
        mt: 4,
        mb: 6,
      }}
    >
      <Grid container spacing={2}>
        {/* PRODUCT FILTER SIDEBAR AREA */}
        <Grid
          item
          md={3}
          sx={{
            display: {
              md: "block",
              xs: "none",
            },
          }}
        >
          <ProductFilterCard shouldHideFilters={total <= 0} />
        </Grid>

        {/* PRODUCT VIEW AREA */}
        <Grid item md={9} xs={12}>
          <SearchResultControl
            search={search}
            quantity={total}
            orderBy={orderBy}
            orderByOptions={props.orderByOptions}
            currentView={view}
            toggleView={toggleView}
          />
          <ProductResultList
            products={products}
            pagingText={pagingText}
            pagingProps={{
              page: currentPage,
              count: Math.floor(total / limit) + (total % limit !== 0 ? 1 : 0),
              variant: "outlined",
              color: "primary",
            }}
            viewMode={view}
            featuredOption={props.featuredOption}
            bgImg={featuredBgImg}
          />
        </Grid>
      </Grid>
    </Container>
  );
};

export default SalifyCollectionSection;
